// extracted by mini-css-extract-plugin
module.exports = {"root":"MemorabiliaListItem_root__9FwkD","infoWrapper":"MemorabiliaListItem_infoWrapper__ie_l6"};